<template>
  <div>
    <list row-key="UserId" ref="list" unit="订单" :expand-all-row="true" :page="page" :query-params="params"
      :show-checkbox="false" :show-query="showQuery" :get-data-func="api.list" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="所属组织">
          <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="null"
            :clearable="true" :accordion="true" :parentSelect="true" placeholder="请选择"
            @node-select="onTreeSelect($event)" />
        </el-form-item>
        <el-form-item label="学员名称">
          <el-input v-model="params.StudentName" placeholder="请填写学员名称" clearable />
        </el-form-item>
        <el-form-item label="培训科目">
          <el-select v-model="params.Subjects" multiple clearable>
            <el-option value="科目二" />
            <el-option value="科目三" />
          </el-select>
        </el-form-item>
        <el-form-item label="培训课程">
          <el-select v-model="params.Courses" clearable multiple>
            <el-option value="实操" />
            <el-option value="模拟" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="params.PayWay" clearable>
            <el-option v-for="item in payList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付日期">
          <el-date-picker v-model.trim="params.DateStart" placeholder="请选择日期" value-format="yyyy-MM-dd" style="width:193px;" />
          <span style="margin:0 10px;">-</span>
          <el-date-picker v-model.trim="params.DateEnd" placeholder="请选择日期" value-format="yyyy-MM-dd" style="width:193px;"/>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="归属机构" min-width="150px" />
        <el-table-column prop="StudentName" label="学员名称" />
        <el-table-column prop="Mobile" label="手机号码" min-width="100px" />
        <el-table-column prop="Subject" label="培训科目" />
        <el-table-column prop="Course" label="培训课程" />
        <el-table-column prop="PayAmount" label="支付金额" />
        <el-table-column prop="PayWay" label="支付方式" />
        <el-table-column prop="PayNo" label="支付流水" min-width="100px" />
        <el-table-column prop="PayTime" label="支付时间" min-width="110px" />
        <el-table-column prop="DriveSchoolAmount" label="驾校分成金额" width="110px" />
        <el-table-column prop="OperatorAmount" label="运营商分成金额" width="110px" />
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
  var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [listMixin],
    components: { list, treeSelect },
    data() {
      return {
        api: require("@/api/op/order").default,
        basicApi: require("@/api/basic/data").default,
        dpApi: require("@/api/basic/dp").default,
        params: {
          DpIdChain: "",
          StudentName: "",
          Subjects: [],
          Courses: [],
          PayWay: "",
          DateStart: "",
          DateEnd: "",
        },
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
        TreeData: [],
        payList: [],
      };
    },
    beforeMount() {
      this.basicApi.list({ ClassName: "付款方式", Status: 1 }).then(res => {
        this.payList = res.Data
      });
      this.dpApi.getAuthList({ DpTypes: [2,3], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      });
    },
    methods: {
      onExport() {
        this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
      },
      onTreeSelect(t) {
        if (!t) {
          this.params.DpIdChain = "";
        } else {
          this.params.DpIdChain = t.IdChain;
        }
      },
      reset() {
        this.$refs.treeSelect.clearHandle();
      },
    },
  };
</script>